import type { RouteRecordRaw } from 'vue-router'

/** 订单中心路由（PLAN-H5-03）；订单详情随切片 2 就位 */
export const orderRoutes: RouteRecordRaw[] = [
  {
    path: '/dynamicPackage/orderList',
    name: 'DynamicPackageOrderList',
    component: () => import('../views/orderList/index.vue'),
    meta: { title: '订单列表' }
  },
  {
    path: '/dynamicPackage/orderDetail',
    name: 'DynamicPackageOrderDetail',
    component: () => import('../views/orderDetail/index.vue'),
    meta: { title: '订单详情' }
  }
]
